import { TranslatePipe } from '../shared/i18n/translate.pipe';
import { TranslationService } from '../shared/i18n/translation.service';
import { Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { ApiService } from '../shared/services/api.service';

@Component({
  selector: 'app-adherer',
  standalone: true,
  imports: [TranslatePipe,CommonModule, FormsModule],
  templateUrl: './adherer.html',
  styleUrls: ['./adherer.scss']
})
export class AdhererComponent {
  readonly translateService = inject(TranslationService);
  private readonly api = inject(ApiService);
  readonly sending = signal(false);
  readonly success = signal(false);
  readonly error = signal('');

  readonly parcoursImage = computed(() =>
    this.translateService.language() === 'en'
      ? 'integration/parcours-en.png'
      : 'integration/parcours-fr.png'
  );
  // Gère l'étape active : 1 = Choix adhésion, 2 = Adhérents/Infos, 3 = Récapitulatif
  public currentStep: number = 1;

  public formData = {
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    ville: '',
    egliseLocale: '',
    profil: 'Etudiant',
    motivation: '',
    travailleurCount: 0,
    nonTravailleurCount: 1,
    solidaireCount: 0,
    donType: 'pas_de_don',
    donMontantLibre: 0
  };

  increment(type: 'travailleur' | 'nonTravailleur' | 'solidaire') {
    if (type === 'travailleur') this.formData.travailleurCount++;
    if (type === 'nonTravailleur') this.formData.nonTravailleurCount++;
    if (type === 'solidaire') this.formData.solidaireCount++;
  }

  decrement(type: 'travailleur' | 'nonTravailleur' | 'solidaire') {
    if (type === 'travailleur' && this.formData.travailleurCount > 0) this.formData.travailleurCount--;
    if (type === 'nonTravailleur' && this.formData.nonTravailleurCount > 0) this.formData.nonTravailleurCount--;
    if (type === 'solidaire' && this.formData.solidaireCount > 0) this.formData.solidaireCount--;
  }

  get totalCotisation(): number {
    return (this.formData.travailleurCount * 240) + (this.formData.nonTravailleurCount * 120);
  }

  // Navigation par étape
  nextStep() {
    if (this.currentStep < 3) {
      this.currentStep++;
      window.scrollTo({ top: 400, behavior: 'smooth' });
    }
  }

  prevStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
      window.scrollTo({ top: 400, behavior: 'smooth' });
    }
  }

  onSubmit(form: NgForm) {
    if (form.invalid || this.sending()) return;
    this.sending.set(true); this.success.set(false); this.error.set('');
    this.api.submitMembership(this.formData).subscribe({
      next: () => {
        this.sending.set(false); this.success.set(true);
        form.resetForm({ profil: 'Etudiant', travailleurCount: 0, nonTravailleurCount: 1, solidaireCount: 0, donType: 'pas_de_don', donMontantLibre: 0 });
      },
      error: err => { this.sending.set(false); this.error.set(err.error?.error || 'pages.adherer.adherer.error'); }
    });
  }
}
